import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><path d="M8 1a7 7 0 100 14A7 7 0 008 1zM6 5c.559 0 1.031.473 1.031 1.031V7c0 .558-.472 1-1.03 1-.56 0-1-.442-1-1v-.969C5 5.473 5.44 5 6 5zm3.438 1h.906c.522 0 .969.216.969.5 0 .284-.447.5-.97.5h-.905c-.523 0-.938-.216-.938-.5 0-.284.415-.5.938-.5zM3 9.063C3.716 10.136 5.235 11 8 11c2.452 0 4.211-.75 5-1.938v.5c0 .681-.838 2.407-5 2.407-3.88 0-5-1.874-5-2.406z" fill="#474747" /></svg>;
}

export default SvgComponent;